export default __webpack_public_path__ + "img/cancel.21b0f416.svg";